var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "434.000000pt",
    height: "426.000000pt",
    viewBox: "0 0 434.000000 426.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,426.000000) scale(0.100000,-0.100000)",
    fill: "#C0BFC7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3315 3775 c-71 -7 -158 -16 -193 -19 l-63 -6 -97 -98 c-53 -53 -112 -114 -130 -135 l-34 -37 22 -53 c12 -28 32 -72 43 -95 l20 -44 -41 -40 -40 -41 -98 42 -98 42 -96 -96 -97 -96 18 -37 c9 -20 29 -63 44 -95 l27 -59 -38 -39 c-40 -41 -53 -46 -82 -29 -9 6 -48 24 -86 40 l-70 31 -133 -133 -133 -133 278 -278 277 -277 553 553 552 552 10 100 c34 351 35 369 14 410 -41 83 -92 94 -329 70z m17 -562 c21 -20 38 -42 38 -47 0 -14 -811 -826 -825 -826 -13 0 -85 72 -85 84 0 14 811 826 825 826 5 0 26 -17 47 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317 2746 c-21 -8 -55 -26 -75 -40 -20 -14 -198 -186 -394 -383 -296 -297 -361 -367 -382 -413 -33 -71 -35 -156 -5 -237 20 -54 51 -88 513 -551 557 -559 542 -547 681 -547 134 0 129 -3 549 417 425 426 421 420 421 558 0 80 -2 90 -35 143 -23 39 -186 208 -520 541 -455 453 -489 485 -543 505 -66 24 -153 27 -210 7z m513 -1721 c0 -6 -43 -53 -95 -105 l-95 -95 -470 470 c-259 258 -470 473 -470 476 0 4 44 50 97 103 l97 97 468 -468 c257 -257 468 -473 468 -478z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSystem);
export default __webpack_public_path__ + "static/media/LockSystem.93a016b13c55e4845bc39ff886ad5a23.svg";
export { ForwardRef as ReactComponent };